import axios from "axios";
import { getToken } from "@/utils/authHelpers";
import { API_BASE_URL } from "@/utils/api";

export const checkPerformanceStatusApi = async (
  transactionId: string,
): Promise<any> => {
  const token = await getToken();
  const response = await axios.get(
    `${API_BASE_URL}/performance-status/${transactionId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};
